export default "__VITE_ASSET__DYM329TL__"